import React from "react";
import { Clock, Tag, Users, Award } from "react-feather";
import { RootStore, useAppSelector } from "../../../store/store";
import { Card } from "../../../shared/Card/Card";
import "./allInterviewLogsStats.scss";

const AllInterviewLogsStats = () => {
  const interviewLogsState = useAppSelector(
    (store: RootStore) => store.InterviewLogsSlice
  );
  const { interviewLogs, loading, total, stats } = interviewLogsState;

  if (loading.fetchInterviewLogs) {
    return (
      <div className="stats-loading">
        <div className="skeleton-card" />
        <div className="skeleton-card" />
        <div className="skeleton-card" />
        <div className="skeleton-card" />
      </div>
    );
  }

  // Use stats from API if available, otherwise calculate from interview logs data
  const completedInterviews =
    stats?.completedInterviews ||
    interviewLogs.filter(
      (interview: any) =>
        interview.status === "completed" || interview.status === "Completed"
    ).length;
  const uniqueUsers =
    stats?.uniqueUsers ||
    new Set(interviewLogs.map((interview: any) => interview.userId)).size;
  
  let averageScore = 0;
  if (stats?.avgPerformance) {
    averageScore = Math.round(stats.avgPerformance * 10); // Convert from out of 10 to percentage
  } else if (interviewLogs.length > 0) {
    const totalScore = interviewLogs.reduce(
      (sum: number, interview: any) => sum + (interview.score || 0),
      0
    );
    averageScore = Math.round(totalScore / interviewLogs.length);
  }

  return (
    <div className="all-interview-logs-stats">
      <Card>
        <div className="stat-item">
          <Clock className="stat-icon blue" />
          <div>
            <p className="stat-label">Total Interviews</p>
            <p className="stat-value">
              {stats?.totalInterviews || total || 0}
            </p>
          </div>
        </div>
      </Card>

      <Card>
        <div className="stat-item">
          <Users className="stat-icon green" />
          <div>
            <p className="stat-label">Unique Users</p>
            <p className="stat-value">{uniqueUsers}</p>
          </div>
        </div>
      </Card>

      <Card>
        <div className="stat-item">
          <Tag className="stat-icon purple" />
          <div>
            <p className="stat-label">Completed Interviews</p>
            <p className="stat-value">{completedInterviews}</p>
          </div>
        </div>
      </Card>

      <Card>
        <div className="stat-item">
          <Award className="stat-icon orange" />
          <div>
            <p className="stat-label">Avg Performance</p>
            <p className="stat-value">{`${averageScore}%`}</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AllInterviewLogsStats;

